export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.config.errorHandler = (error, instance, info) => {
        //this handler will capture any non-handled error and will log it into New Relic as and error object
        newrelic.noticeError(error);
    }
});
